import React, { useState, useRef } from "react";
import ScrollAnimation from "../components/ScrollAnimation";
import { img } from "../constants/copy";
import { FILMS, videoSrc } from "../constants/videos";

export default function Films() {
  // ✅ Hooks always first
  const [expanded, setExpanded] = useState(null);

  // refs to control playback
  const heroRef = useRef(null);
  const smallRefs = useRef({});

  // safety guard
  if (!Array.isArray(FILMS) || FILMS.length < 3) return null;

  const [hero, left, right] = FILMS;

  const toggleReadMore = (slug) => {
    setExpanded((prev) => (prev === slug ? null : slug));
  };

  // ensure only one video plays at a time
  const handlePlay = (slug) => {
    if (heroRef.current) heroRef.current.pause();

    Object.entries(smallRefs.current).forEach(([key, video]) => {
      if (key !== slug && video) video.pause();
    });
  };

  return (
    <section className="bg-[#081a2b] px-4 sm:px-6 md:px-10 lg:px-14 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">

        {/* HERO VIDEO (AUTOPLAY) */}
        <ScrollAnimation>
          <div className="relative overflow-hidden rounded-xl border border-white/10 shadow-xl">
            <video
              ref={heroRef}
              src={videoSrc(hero.video)}
              poster={img(hero.poster)}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              controls
              className="w-full aspect-video object-cover"
            />
          </div>
        </ScrollAnimation>

        {/* CENTER TITLE */}
        <ScrollAnimation>
          <h2 className="mt-10 mb-16 text-center font-inria font-light text-xl sm:text-2xl md:text-3xl text-white/90 tracking-wide">
            Unforgettable Moments · Timeless Films
          </h2>
        </ScrollAnimation>

        {/* SMALL VIDEOS */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {[left, right].map(
            ({ slug, title, location, description, video, poster }) => {
              const isOpen = expanded === slug;

              return (
                <ScrollAnimation key={slug}>
                  <div className="space-y-4">
                    <div className="relative overflow-hidden rounded-xl border border-white/10 shadow-lg">
                      <video
                        ref={(el) => (smallRefs.current[slug] = el)}
                        src={videoSrc(video)}
                        poster={img(poster)}
                        controls
                        playsInline
                        preload="metadata"
                        onPlay={() => handlePlay(slug)}
                        className="w-full aspect-video object-cover"
                      />
                    </div>

                    {/* CAPTION */}
                    <div className="text-white/85 font-inter text-sm leading-relaxed">
                      <h3 className="font-inria font-light text-lg text-white">
                        {title}
                      </h3>

                      <p className="text-white/60 text-xs uppercase tracking-widest mb-2">
                        {location}
                      </p>

                      <p className={isOpen ? "" : "line-clamp-3"}>
                        {description}
                      </p>

                      <button
                        onClick={() => toggleReadMore(slug)}
                        className="mt-2 text-xs uppercase tracking-widest text-weddmac-gold hover:opacity-80 transition"
                        aria-expanded={isOpen}
                      >
                        {isOpen ? "Read Less" : "Read More"}
                      </button>
                    </div>
                  </div>
                </ScrollAnimation>
              );
            }
          )}
        </div>

      </div>
    </section>
  );
}
